/**
 * Pure functions for pre-signature verdict mapping and styling.
 * No React, no routing, no external dependencies.
 * Extracted for testability and reusability.
 */

export const VERDICT_SLUG = {
  "Sign": "sign",
  "Sign with conditions": "sign_with_conditions",
  "Renegotiate": "renegotiate",
  "Do not sign": "do_not_sign",
};

export const VERDICT_TONE = {
  sign: "bg-emerald-600 text-white",
  sign_with_conditions: "bg-amber-500 text-white",
  renegotiate: "bg-orange-600 text-white",
  do_not_sign: "bg-rose-600 text-white",
  unknown: "bg-zinc-500 text-white",
};

export function verdictKey(verdict) {
  return `verdict.${VERDICT_SLUG[verdict] || "unknown"}`;
}
